<div class="modal-header">
  <h3 class="modal-title text-center">Ajouter une carte de crédit</h3>
</div>
<div class="modal-body">
  <div class="alert visually-hidden" id="message"></div>

  <div id="payment-element">
    <div class="spinner-border" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <!-- the payment element will be mounted here -->
  </div>
</div>
<div class="modal-footer">
  <button (click)="createPaymentMethod()" [disabled]="isCreditCardDisabled" class="btn btn-primary" type="button">
    @if (isCreditCardDisabled === false) {
      <span>
        <i
        class="fa fa-credit-card"></i>
        Ajouter la carte de crédit
      </span>
    }
    @if (isCreditCardDisabled) {
      <span>
        <span aria-hidden="true" class="spinner-border spinner-border-sm" role="status"></span>
        Ajout en cours...
      </span>
    }
  </button>
  <button (click)="activeModal.close()" class="btn btn-white" type="button">Annuler</button>
</div>
